import pizza_img from "./images/local_pizza-24px.svg";
import cronometro_img from "./images/alarm-24px.svg";
import nombre_archivos_img from "./images/description-24px.svg";
import presupuesto_img from "./images/calculate-24px.svg";
import citas_img from "./images/local_pharmacy-24px.svg";
import cotizador_img from "./images/directions_car-24px.svg";
import frases_img from "./images/sticky_note_2-24px.svg";

const proyects = [
  {
    name: "Pizzas",
    description:
      "Con esta aplicación podrás ver las pizzas y promociones que se tienen registrados. Si te logeas como administrador te permite dar de alta pizzas y promociones, así como otras opciones. Conectado con la base de datos Fire Base.",
    url: "https://pizzatienda.netlify.app/",
    image: pizza_img,
  },
  {
    name: "Cronometro",
    description:
      "Con esta aplicación podrás programar el tiempo en segundos de ejercicio, así como el tiempo de descanso y el número de repeticiones. Además, se guardará un historial de ejercicios realizados.",
    url: "https://cronometroapp.netlify.app/",
    image: cronometro_img,
  },
  {
    name: "Nombre Archivos",
    description:
      "Con esta aplicación podrás obtener el listado de nombres de archivos que se seleccionen desde el explorador de Windows.",
    url: "https://nombrearchivos.netlify.app/",
    image: nombre_archivos_img,
  },
  {
    name: "Presupuesto",
    description:
      "Con esta aplicación te permite administrar tu presupuesto, así como ir agregando tus gastos.",
    url: "https://presupuestoweb.netlify.app/",
    image: presupuesto_img,
  },
  {
    name: "Citas",
    description:
      "Con esta aplicación podrás agregar citas de tus mascotas y eliminar.",
    url: "https://citasmascotasapp.netlify.app/",
    image: citas_img,
  },
  {
    name: "Cotizador",
    description:
      "Con esta aplicación podrás obtener la cotización de un seguro de auto dependiendo de la marca, año y plan.",
    url: "https://cotizadorseguroapp.netlify.app/",
    image: cotizador_img,
  },
  {
    name: "Frases",
    description:
      "Con esta aplicación podrás obtener frases random de la serie Breakin Bad.",
    url: "https://frasesbreakingbadapp.netlify.app/",
    image: frases_img,
  },
];

export default proyects;
